import { render, staticRenderFns } from "./ContactsViewRol.vue?vue&type=template&id=02fe1036&scoped=true&"
import script from "./ContactsViewRol.vue?vue&type=script&lang=js&"
export * from "./ContactsViewRol.vue?vue&type=script&lang=js&"
import style0 from "./ContactsViewRol.vue?vue&type=style&index=0&id=02fe1036&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fe1036",
  null
  
)

export default component.exports